import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCompanies } from '../../../store/employee/actions';
import { getNews, deleteNews } from '../../../store/news/actions';
import { NewsConfrimationModal } from './NewsDeleteConfirmation';
import { formatDate } from '../../../helpers/formatterHelper';
import { showLoading, hideLoading } from '../../../store/loading-reducer';
import { AddUpdatePin } from '../../../api/news';
import { useAdminMenuContext } from "../../../context/AdminMenuContext";
import { AdminModal } from "../../../components/admin/admin-modal";
import DatePicker from "react-datepicker";

function News() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [filter, setFilter] = useState({ query: '', companyId: 0, sort: 6, mostRecent: false, IsShowPastEvent :false });
    const { companiesList } = useSelector(state => state.employee);
    const { newsList } = useSelector(state => state.news); 
    const [newsModel, setNewsModel] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [editLink, setEditLink] = useAdminMenuContext('');
    const [showPinModal, setShowPinModal] = useState(false);
    const [pinnedExpirationInputValue, setPinnedExpirationInputValue] = useState(newsModel.pinnedExpiration ? new Date(newsModel.pinnedExpiration) : new Date());


    const handleDateFormate = (date) => {
        const inputDate = date;
        let formattedDate = inputDate.replace(/\D/g, ''); // Remove all non-digit characters
        if (formattedDate.length > 2 && formattedDate.length <= 4) {
            formattedDate = formattedDate.slice(0, 2) + '/' + formattedDate.slice(2);
        } else if (formattedDate.length > 4) {
            formattedDate = formattedDate.slice(0, 2) + '/' + formattedDate.slice(2, 4) + '/' + formattedDate.slice(4, 8);
        }
        return formattedDate;
    };

    const isValidDateFormat = (dateString) => {
        // Define a regular expression pattern for the desired format (mm/dd/yyyy)
        const dateFormatPattern = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

        // Check if the dateString matches the pattern
        return dateFormatPattern.test(dateString);
    }

    const handleFilterCompany = (e) => {
        const selectedCompanyId = parseInt(e.target.value);
        setFilter({ ...filter, companyId: selectedCompanyId });
    };

    //useEffect(() => {
    //    const adjustHappeningEditHeight = () => {
    //        const happeningEdit = document.querySelector(".happening-edit");
    //        const datePickerWrapper = document.querySelector(".react-datepicker-wrapper");
    //        const dateTabLoop = document.querySelector(".react-datepicker__tab-loop");

    //        if (happeningEdit) {
    //            if (datePickerWrapper && dateTabLoop) {
    //                happeningEdit.style.height = "55%"; // Adjust as needed
    //            } else {
    //                happeningEdit.style.height = ""; // Reset height
    //            }
    //        }
    //    };
    //    // Run the adjustment after the modal opens
    //    if (showPinModal) {
    //        const observer = new MutationObserver(() => {
    //            adjustHappeningEditHeight();
    //        });

    //        observer.observe(document.body, {
    //            childList: true,
    //            subtree: true,
    //        });

    //        // Adjust once immediately
    //        adjustHappeningEditHeight();

    //        // Cleanup
    //        return () => {
    //            observer.disconnect();
    //        };
    //    }
    //}, [showPinModal]);

    useEffect(() => {     
        document.title = 'Happenings | CWP Employee Portal';
        dispatch(showLoading());
        dispatch(getCompanies());
        setEditLink('/news-tiles');
        console.log(editLink)
    }, []);
     
    useEffect(() => {
        dispatch(getNews(filter)).unwrap().then(() => {
            dispatch(hideLoading());
        });
    }, [filter]);

    const handleDeleteTrigger = (id ,title) => {
        setNewsModel({ id: id, title: title });
        setShowDeleteModal(true);
    }
    const handleDeleteNews = (item) => {
        dispatch(deleteNews(item.id));
    }
    const handlePinTrigger = (pinData) => {
        //if (pinData.pinnedDateTime) {
        //    handleAddEditPinned(pinData);
        //}
        //else {
        //    setNewsModel(pinData);
        //    setShowPinModal(true);
        //}
        handleAddEditPinned(pinData);
    }
    const handleExpirationDateChange = (event) => {
        if (event.type === "change") {
            const formattedDate = handleDateFormate(event.target.value);
            setPinnedExpirationInputValue(formattedDate);
            if (isValidDateFormat(formattedDate)) {
                setNewsModel({ ...newsModel, pinnedExpiration: new Date(formattedDate) });
            }
        }
    };
    const handlePinModalSave = (item) => {
        handleAddEditPinned(item);
        setShowPinModal(false);
    }
    const handleAddEditPinned = (pinData) => {
        AddUpdatePin(pinData)
            .then((response) => {            
                if (response.data.success) {
                    dispatch(getNews(filter));
                    dispatch(hideLoading());
                }
            })
            .catch((error) => {
                dispatch(hideLoading());
                if (error.response.data && error.response.data.message) {
                    console.log(error.response.data.message);
                } else {
                    console.log(error.response.responseText);
                }
            });
  
    }

    return (
        <>
            <NewsConfrimationModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                handleDeleteNews={handleDeleteNews}
                modelNews={newsModel}
            />
            <AdminModal
                show={showPinModal}
                modalTitle="Pin this Event"
                adminModalClass="happening-edit"
                onClose={() => setShowPinModal(false)}
                onSave={handlePinModalSave}
                model={newsModel}
            >
                <label className="admin-default-label">Set Expiration Date</label>
                <DatePicker
                    className="admin-default-input-text"
                    selected={newsModel.pinnedExpiration ? new Date(newsModel.pinnedExpiration) : null} 
                    placeholder="mm/dd/yyyy"
                    autoComplete="off"
                    onChange={(date) => { 
                        setNewsModel({ ...newsModel, pinnedExpiration: date });
                    }}
                    onChangeRaw={handleExpirationDateChange}
                    value={pinnedExpirationInputValue}
                    minDate={Date.now()}
                />
            </AdminModal>
            <div className="admin-page-wrap">
                <div className="admin-top-bar-wrap">
                    <div className="admin-top-bar-left">
                        <Link className="admin-top-bar-back" to={'/siteadmin'}>Back</Link>
                    </div>
                </div>

                <div className="pageContainer">
                    <div className="admin-page-content">
                        <div className="admin-page-title-wrap">
                            <h1 className="admin-page-heading">Happenings</h1>
                            <button className="admin-button"
                                onClick={() =>
                                    navigate('/siteadmin/news/create')
                                }
                            >
                                <span>Add Happenings</span>
                                <span className="material-symbols-rounded">add</span>
                            </button>
                        </div>
                        <div className="admin-bottom-bar filter-bars">
                            <div className="admin-bottom-bar-left">
                                <select className="admin-default-select quoteradius" onChange={handleFilterCompany} value={filter.companyId}>
                                    <option value="0">All</option>
                                    {companiesList && companiesList.length > 0 &&
                                        companiesList.map(item => (
                                            <option key={item.id} value={item.id}>{item.abbreviatedName}</option>
                                        ))}
                                </select>
                            </div>
                        </div>

                        <div className="pt">
                            <table className="admin-table">
                                <tbody>
                                    <tr> 
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 1 ? 2 : 1 })} className={filter.sort == 1 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 2 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Happenings Title</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 3 ? 4 : 3 })} className={filter.sort == 3 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 4 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Organization</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 9 ? 10 : 9 })} className={filter.sort == 9 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 10 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Publish Date</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 7 ? 8 : 7 })} className={filter.sort == 7 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 8 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Shop Monitor</th>
                                        <th className="admin-table-action-cell">&nbsp;</th>
                                        <th className="admin-table-action-cell">&nbsp;</th>
                                        <th className="admin-table-action-cell">&nbsp;</th>
                                    </tr>
                                    {newsList && newsList.length > 0 ? (
                                        newsList.map(item => (
                                            <tr key={item.id}>                                               
                                                <td className="admin-table-name-cell">{item.title}</td>
                                                <td className="admin-table-name-cell">
                                                    {item.companyInfo}
                                                </td> 
                                                <td className="admin-table-name-cell">
                                                    {item.publishDate && item.publishDate.length > 0 ? ( 
                                                        <span>{formatDate(item.publishDate)}</span>     
                                                       
                                                    ) : (
                                                        <span></span>
                                                    )}</td> 
                                                <td className="admin-table-name-cell">
                                                    {item?.isShopMonitor ? "Yes" : "No"}
                                                </td> 
                                                <td className="admin-table-name-cell">
                                                    <button className="admin-table-action" onClick={() => handlePinTrigger(item)}>
                                                        {item?.pinnedDateTime ? (
                                                            <>
                                                                <span className="material-symbols-rounded">keep</span>
                                                            </>
                                                        ) : (
                                                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                                                                <path d="m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40v280Zm-286 80h252l-46-46v-314H400v314l-46 46Zm126 0Z" />
                                                            </svg>
                                                        )}
                                                    </button>
                                                </td>

                                                <td className="admin-table-name-cell">
                                                    <button className="admin-table-action" onClick={() => navigate('/siteadmin/news/edit/' + item.baseId)}>
                                                        <span className="material-symbols-rounded">edit</span>
                                                    </button>
                                                </td>

                                                <td className="admin-table-name-cell">
                                                    <button className="admin-table-action" onClick={() => handleDeleteTrigger(item.id, item.title)}>
                                                        <span className="material-symbols-rounded">delete</span>
                                                    </button>
                                                </td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="admin-table-name-cell" colSpan="6">No active Happenings</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default News;